export const EMPTY_OBJECT = {};
export function getHeadersObj(headers) {
    return new Proxy(EMPTY_OBJECT, {
        get(_target, prop) {
            return headers.get(prop) || undefined;
        },
        set(_target, prop, value) {
            headers.set(prop, value);
            return true;
        },
        has(_target, prop) {
            return headers.has(prop);
        },
        deleteProperty(_target, prop) {
            headers.delete(prop);
            return true;
        },
        ownKeys() {
            return [...headers.keys()];
        },
        getOwnPropertyDescriptor() {
            return {
                enumerable: true,
                configurable: true,
            };
        },
    });
}
